export default {"src":"/_next/static/media/ly.e22eb76b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};